import { FieldID } from '../types';

const TOOLTIP_LABELS: { [key in FieldID]?: string } = {
  apartment_number: 'widget.delivery_address.APARTMENT_NUMBER_TOOLTIP',
  phone_number: 'widget.delivery_address.PHONE_NUMBER_TOOLTIP',
  email: 'widget.delivery_address.EMAIL_TOOLTIP',
};

export const getTooltipMessage = (name: FieldID) => {
  return TOOLTIP_LABELS[name] || '';
};
